import { t, getIntlLocale } from "@i18n";

const H = {
  pretty: {
    int(number) {
        return new Intl.NumberFormat('de-DE').format(number)
    },
    date(dateString){
        const dateObj = new Date(dateString);

        // "4 de setembro" in pt-BR, "September 4" in en-US, "4 de septiembre" in es-ES
        const date = dateObj.toLocaleDateString(getIntlLocale(), { day: 'numeric', month: 'long' });
        const hours = dateObj.getHours().toString().padStart(2, '0');
        const minutes = dateObj.getMinutes().toString().padStart(2, '0');

        return t('common:time.dateAtTime', { date, time: `${hours}:${minutes}` });
    },
    money(value){
      if (!value) return value;
      const numericValue = `${value}`?.replace(/\D/g, "");
      const integerPart = numericValue.slice(0, -2)?.replace(/^0+/, "") || "0";
      const decimalPart = numericValue.slice(-2);

      const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

      return `${formattedInteger},${decimalPart}`;
    }
  },
};

export default H;
